import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import { Option, OptionValue } from '@/entities/rain/dropdown'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import { faChevronDown, faChevronUp } from 'fontawesome/free-solid-svg-icons'
import Checkbox from '@/components/Rain/Inputs/Checkbox.vue'

interface Props {
    options?: Option[]
    values?: OptionValue
    label?: string
    disabled?: boolean
    error?: boolean
    showLabel?: boolean
    floatingDropdown?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownMultiCheckbox',
  props: {
    options: { default: () => [] },
    values: { default: () => [] },
    label: { default: '' },
    disabled: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    showLabel: { type: Boolean, default: true },
    floatingDropdown: { type: Boolean, default: false }
  },
  emits: ['change'],
  setup(__props: any, { emit }) {

const props = __props as { options: Option[], values: OptionValue, label: string, disabled: boolean, error: boolean, showLabel: boolean, floatingDropdown: boolean };




const dropdownActive = ref(false)

const selectedOptionsLabels = computed(() => {
    return props.values.map((obj: Option) => obj.label).join(', ')
})

const isSelected = (option: Option) => {
    return props.values.some((obj: Option) => obj.value === option.value)
}

const selectOption = (option: Option, checked: boolean) => {
    emit('change', option, checked)
}

return { __sfc: true,props, emit, dropdownActive, selectedOptionsLabels, isSelected, selectOption, FontAwesomeIcon, faChevronDown, faChevronUp, Checkbox }
}

})